export enum RefereeLicense {
  SUPERLIGA_A = 'superliga_a',
  SUPERLIGA_B = 'superliga_b',
  SUPERLIGA_TRAINEE = 'superliga_trainee',
  OS_A = 'os_a',
  OS_B = 'os_b',
  OS_C = 'os_c',
}
